var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineaB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_049-electronics",
    "data-name": "049-electronics",
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.828,
    height: 84.828,
    viewBox: "0 0 84.828 84.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_259",
    "data-name": "Trazado 259",
    d: "M294.172,0H257.414A1.414,1.414,0,0,0,256,1.414V80.586A1.414,1.414,0,0,0,257.414,82h1.414v2.828h2.828V82h28.276v2.828h2.828V82h1.414a1.414,1.414,0,0,0,1.414-1.414V1.414A1.414,1.414,0,0,0,294.172,0Zm-1.414,79.172H258.828V29.69h33.931Zm0-52.31H258.828V2.828h33.931Zm0,0",
    transform: "translate(-210.759 0)",
    fill: "#003082"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_260",
    "data-name": "Trazado 260",
    d: "M296,56h2.828V70.138H296Zm0,0",
    transform: "translate(-243.69 -46.103)",
    fill: "#86888b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_261",
    "data-name": "Trazado 261",
    d: "M296,184h2.828v19.793H296Zm0,0",
    transform: "translate(-243.69 -151.483)",
    fill: "#86888b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_262",
    "data-name": "Trazado 262",
    d: "M1.414,220.31H2.828v2.828H5.655V220.31h31.1v2.828h2.828V220.31H41a1.414,1.414,0,0,0,1.414-1.414V169.414A1.414,1.414,0,0,0,41,168H1.414A1.414,1.414,0,0,0,0,169.414V218.9A1.414,1.414,0,0,0,1.414,220.31Zm1.414-49.483H39.586v8.483H2.828Zm0,11.31H39.586v35.345H2.828Zm0,0",
    transform: "translate(0 -138.31)",
    fill: "#003082"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_263",
    "data-name": "Trazado 263",
    d: "M47.552,256A15.552,15.552,0,1,0,63.1,271.552,15.552,15.552,0,0,0,47.552,256Zm0,28.276a12.724,12.724,0,1,1,7.933-22.656l-2.009,2.014a9.918,9.918,0,1,0-.024,15.822l2.033,2.033A12.647,12.647,0,0,1,47.552,284.276Zm3.242-7.483.641.641a7.069,7.069,0,1,1,.007-11.77l-.648.647a1.414,1.414,0,0,0-.414,1v8.483a1.414,1.414,0,0,0,.414,1Zm6.69,2.686-4.277-4.271V267.9l4.277-4.277a12.664,12.664,0,0,1,0,15.865Zm0,0",
    transform: "translate(-26.345 -210.759)",
    fill: "#003082"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_264",
    "data-name": "Trazado 264",
    d: "M32,200h2.828v2.828H32Zm0,0",
    transform: "translate(-26.345 -164.655)",
    fill: "#86888b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_265",
    "data-name": "Trazado 265",
    d: "M64,200h2.828v2.828H64Zm0,0",
    transform: "translate(-52.69 -164.655)",
    fill: "#86888b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_266",
    "data-name": "Trazado 266",
    d: "M96,200h2.828v2.828H96Zm0,0",
    transform: "translate(-79.034 -164.655)",
    fill: "#86888b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_267",
    "data-name": "Trazado 267",
    d: "M160,200h8.483v2.828H160Zm0,0",
    transform: "translate(-131.724 -164.655)",
    fill: "#86888b"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_268",
    "data-name": "Trazado 268",
    d: "M1.414,26.862H41a1.414,1.414,0,0,0,1.414-1.414V1.414A1.414,1.414,0,0,0,41,0H1.414A1.414,1.414,0,0,0,0,1.414V25.448A1.414,1.414,0,0,0,1.414,26.862ZM31.1,2.828h8.483V24.034H31.1Zm-28.276,0H28.276V24.034H2.828Zm0,0",
    transform: "translate(0 0)",
    fill: "#003082"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_269",
    "data-name": "Trazado 269",
    d: "M192,32h2.828v2.828H192Zm0,0",
    transform: "translate(-158.069 -26.345)",
    fill: "#86888b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_270",
    "data-name": "Trazado 270",
    d: "M192,64h2.828v2.828H192Zm0,0",
    transform: "translate(-158.069 -52.69)",
    fill: "#86888b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_271",
    "data-name": "Trazado 271",
    d: "M50.379,32H33.414A1.414,1.414,0,0,0,32,33.414V46.138a1.414,1.414,0,0,0,1.414,1.414H50.379a1.414,1.414,0,0,0,1.414-1.414V33.414A1.414,1.414,0,0,0,50.379,32ZM48.966,44.724H34.828v-9.9H48.966Zm0,0",
    transform: "translate(-26.345 -26.345)",
    fill: "#003082"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_272",
    "data-name": "Trazado 272",
    d: "M190.121,100a2.121,2.121,0,1,0,2.121,2.121A2.12,2.12,0,0,0,190.121,100Zm0,2.828a.707.707,0,1,1,.707-.707A.707.707,0,0,1,190.121,102.828Zm0,0",
    transform: "translate(-154.776 -82.328)",
    fill: "#86888b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineaB);
export default __webpack_public_path__ + "static/media/linea-b.05d580821cf52eae65f8f2241ca0713b.svg";
export { ForwardRef as ReactComponent };